import { Field } from 'formik';
import * as React from 'react';

import { CheckboxFieldProps } from './types';
import ErrorMessage from '../ErrorMessage';
import muiStyles from '../fieldStyles';

export default function CheckboxField(props: CheckboxFieldProps) {
    const {
        name,
        disabled,
        hideError = false,
        label,
        errors
    } = props;

    const classes = muiStyles(props);

    return (
        <Field
            name={name}
            type='checkbox'
        >
            {({ field, form }) => (
                <label
                    className={`${classes.inputLabel} ${classes.field}`}
                    data-testid={`${name}-label`}
                    htmlFor={name}
                >
                    {label}
                    <div className={classes.checkmarkContainer}>
                        <input
                            {...field}
                            className={classes.checkboxInput}
                            data-testid={`${name}-input`}
                            disabled={disabled}
                            name={name}
                            onChange={(e) => {
                                if (!form.touched[name]) {
                                    form.setFieldTouched(name, true);
                                }
                                field.onChange(e);
                            }}
                            type='checkbox'
                        />
                        <span className={`checkmark ${classes.checkmark}`} />
                    </div>
                    {!hideError && (
                        <ErrorMessage
                            error={errors[field.name]}
                            field={field}
                            form={form}
                        />
                    )}
                </label>
            )}
        </Field>
    );
}